import { render, staticRenderFns } from "./ThirdSection.vue?vue&type=template&id=d64f6608&scoped=true&"
import script from "./ThirdSection.vue?vue&type=script&lang=js&"
export * from "./ThirdSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64f6608",
  null
  
)

export default component.exports